import axios from 'axios'


/**
 * 
 * @status no delete
 * @class ModuleRoleService
 */
class ModuleRoleService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
  * @author Alan Aguilar
  * @description Get the modules of a role bu userRoleId from A3cloud
  * @date 08-09-2020
  * @param {Number} roleId
  * @param {Object} token
  * @returns {Object}
  * @memberof ModuleRoleService
  */
  async getModulesByUserRoleId(roleId, token) {
    let response = await axios.get(`${this.apiUrl}/module-roles?roleId=${roleId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }

  /**
 * @author Junaid Khan
 * @description Get the modules from A3 by assignRoles
 * @date 19-11-2023
 * @status no delete
 * @param {Object} token
 * @returns {Object}
 * @memberof ModuleRoleService
 */
  async getModulesByAssignRoles(token) {
    let response = await axios.get(`${this.apiUrl}/modules-by-assignRoles-passthrough`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }

  /**
* @author Junaid Khan
* @description Get all the modules on left panel
* @date 18-01-2022
* @status no delete
* @param {String} token
* @param {Number} userId
* @returns {Object}
* @memberof UserSignatureProfileService
*/

  async getModulesOnLeftPanel(token) {
    let response = await axios.get(
      `${this.apiUrl}/modules-left-panel-passthrough`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

}

export { ModuleRoleService as default }
